"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _colors = require("HubStyleTokens/colors");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _UIIllustration = _interopRequireDefault(require("UIComponents/image/UIIllustration"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var EmptyShoppingCartText = (0, _styledComponents.default)(_Small.default).withConfig({
  displayName: "EmptyShoppingCart__EmptyShoppingCartText",
  componentId: "nnohtt-0"
})(["width:100%;max-width:140px;color:", ";text-align:center;"], _colors.EERIE);
var EmptyShoppingCartContainer = (0, _styledComponents.default)(_UIFlex.default).withConfig({
  displayName: "EmptyShoppingCart__EmptyShoppingCartContainer",
  componentId: "nnohtt-1"
})(["height:330px;color:", ";"], _colors.BATTLESHIP);

function EmptyShoppingCart() {
  return _react.default.createElement(EmptyShoppingCartContainer, {
    direction: "column",
    align: "center",
    justify: "center"
  }, _react.default.createElement(_UIIllustration.default, {
    name: "store-disabled",
    width: "125px",
    className: "m-bottom-4"
  }), _react.default.createElement(EmptyShoppingCartText, null, _react.default.createElement(_FormattedMessage.default, {
    message: "bundles.shoppingCart.emptyCart"
  })));
}

var _default = EmptyShoppingCart;
exports.default = _default;
module.exports = exports.default;